import React from "react";
import CommonModal from "../components/Modal";
import { ModalProps } from "../components/Modal/Modal.types";

const DiscardCampaignModal: React.FC<ModalProps> = ({
  open,
  onClose,
  onConfirm,
}) => {
  return (
    <CommonModal
      visible={open}
      modalTitle="Discard campaign"
      confirmText="Discard campaign"
      cancelText="Keep campaign"
      iconType={null}
      modalContentDesc={[
        "This will permanently remove this campaign and stop any ongoing activity.",
        "You will not be able to recover it."
      ]}
      onClose={onClose}
      onConfirm={onConfirm}
    />
  );
};

export default DiscardCampaignModal;